export default __webpack_public_path__ + "static/media/lp-service_01.6c1a1298.png";